import { handleActions } from 'redux-actions';
import { getGtmDataLayer } from '@airasia-common/libraries/factories/Analytics';
import { types } from './analytics.meta';

const SEARCH_INIT = 'aa_htl_search_inititated';
const SELECT_HOTEL = 'aa_htl_hotelselect_actions';
const SELECT_ROOM = 'aa_htl_roomselect_actions';
const GUEST_DETAIL_SUBMIT = 'aa_htl_guestdetails_submitted';
const PAYMENT_SUCCESS = 'aa_htl_booking_successful';
const VERSION_GTM = 2;

export const gtmCustomDataLayer = (evt, payload) => {
  return {
    event: evt,
    payload: payload,
    version: VERSION_GTM,
  };
};

export const analyticsEvents = {
  [types.STATUS_CODE_ANALYTICS]: ({ payload: { statusCode, lob, pageId } }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      'Server Status Code',
      `${lob} | ${pageId}`,
      `${statusCode}`
    ),

  [types.TRACK_OPEN_SCREEN]: ({ payload }) => ({
    event: 'trackEventOpenScreen',
    screenName: `${payload}`,
  }),

  [types.RECEIVED_FIRST_BYTE]: ({
    payload: { timeToFirstByte, lob, pageId },
  }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      `${lob} | ${pageId} page`,
      'Received First Byte',
      `${timeToFirstByte} ms`
    ),

  [types.FIRST_RENDER]: ({ payload: { timeToFirstRender, lob, pageId } }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      `${lob} | ${pageId} page`,
      'Partial Page Interactable',
      `${timeToFirstRender} ms`
    ),

  [types.RECEIVE_API_RESPONSE]: ({
    payload: { api, responseTime, lob, pageId },
  }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      `${lob} | ${pageId} page`,
      `${api} API Response Received`,
      `${responseTime} ms`
    ),

  [types.BATCH_CONTENT_DOWNLOAD_COMPLETED]: ({
    payload: { lob, pageId, downloadTime },
  }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      `${lob} | ${pageId} page`,
      'Content Download Complete',
      `${downloadTime} ms`
    ),

  [types.FULL_PAGE_INTERACTABLE]: ({
    payload: { lob, pageId, timeToFullPageInteractable },
  }) =>
    getGtmDataLayer(
      'trackEventNoEcommerce',
      `${lob} | ${pageId} page`,
      'Full Page Interactable',
      `${timeToFullPageInteractable} ms`
    ),
  [types.HOTEL_SEARCH_INIT]: ({ payload }) =>
    gtmCustomDataLayer(SEARCH_INIT, payload),
  [types.HOTEL_SELECT_HOTEL]: ({ payload }) =>
    gtmCustomDataLayer(SELECT_HOTEL, payload),
  [types.HOTEL_SELECT_ROOM]: ({ payload }) =>
    gtmCustomDataLayer(SELECT_ROOM, payload),
  [types.HOTEL_GUEST_DETAIL_SUBMIT]: ({ payload }) =>
    gtmCustomDataLayer(GUEST_DETAIL_SUBMIT, payload),
  [types.HOTEL_PAYMENT_SUCCESS]: ({ payload }) =>
    gtmCustomDataLayer(PAYMENT_SUCCESS, payload),
  [types.HOTEL_SEARCH_WIDGET]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
  [types.ERROR_POP_OUT]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
  [types.SEARCH_AGAIN]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
  [types.NO_HOTELS]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
  [types.VIEW_IMAGE_BANNER]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
  [types.VIEW_ROOM]: ({ payload }) => {
    const event = payload['event'];
    const category = payload['eventDetails.category'];
    const action = payload['eventDetails.action'];
    const label = payload['eventDetails.label'];
    return getGtmDataLayer(event, category, action, label);
  },
};

const initialState = {
  batchContentDownload: [],
};

function trackBatchContentDownload(state, { payload }) {
  const uniqueItems = [...new Set(payload.items)];
  const newBatch = {
    ...payload,
    items: uniqueItems,
    downloadStart: new Date().getTime(),
  };
  return {
    ...state,
    batchContentDownload: [...state.batchContentDownload, newBatch],
  };
}

function updateBatchContentDownload(
  state,
  { payload: { batchContentDownload } }
) {
  return {
    ...state,
    batchContentDownload,
  };
}

export default handleActions(
  {
    [types.BATCH_CONTENT_DOWNLOAD]: trackBatchContentDownload,
    [types.UPDATE_BATCH_CONTENT_DOWNLOAD]: updateBatchContentDownload,
  },
  initialState
);
